<script lang='ts'>
    import type {AchievabilityStatus} from '../modules/ProgramAchievability.js'
    export let status: AchievabilityStatus
    export let statusMessage: string
</script>
<div class:text-red-600={status==="error"} class:text-yellow-600={status==="warning"} class:text-green-600={status==="fine"}>
    <i class="fa-light" class:fa-circle-xmark={status==="error"} class:fa-warning={status==="warning"} class:fa-check-circle={status==="fine"}/>
    {statusMessage}
</div>